/**
 * `<SearchInput>` — the toolbar search field with a left-aligned magnifier,
 * used on every list page. Thin wrapper over the `Input` primitive so the
 * icon + rounded styling live in one place.
 */

import { Input, cn } from "@cometchat-ai/ui-dashboard";
import { Search } from "./icons";

export function SearchInput({
  value,
  onChange,
  placeholder,
  className,
  ...rest
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  "data-testid"?: string;
  "aria-label"?: string;
}) {
  return (
    <div className={cn("relative w-56", className)}>
      <Search
        className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
        aria-hidden="true"
      />
      <Input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={rest["aria-label"] ?? placeholder}
        data-testid={rest["data-testid"]}
        className="h-8 w-full rounded-md pl-8 text-[13px] text-ellipsis placeholder:text-[color:var(--color-fg-subtle)]"
      />
    </div>
  );
}
